import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { usePromptForm } from '../hooks/usePromptForm';
import { PROMPT_CONSTANTS } from '../constants/promptConstants';
import { useExistingPromptNames } from '../hooks/useExistingPromptNames';

const PromptFormContext = createContext();

export const PromptFormProvider = ({ children, promptData = null }) => {
  const { promptId } = useParams();
  const existingPromptNames = useExistingPromptNames();
  const initialData = promptData ? {
    name: promptData.name || "",
    description: promptData.description || "",
    llmModel: promptData.llmModel || "",
    instructions: promptData.instructions || "",
  } : null;

  const formMethods = usePromptForm(
    existingPromptNames,
    PROMPT_CONSTANTS.MAX_INSTRUCTIONS_LENGTH,
    initialData
  );

  const contextValue = {
    ...formMethods,
    promptId,
    promptData
  };

  return (
    <PromptFormContext.Provider value={contextValue}>
      {children}
    </PromptFormContext.Provider>
  );
};

export const usePromptFormContext = () => {
  const context = useContext(PromptFormContext);
  if (!context) {
    throw new Error('usePromptFormContext must be used within a PromptFormProvider');
  }
  return context;
}; 